export const AudienceIds = {
  /** Ninetailed audience ID for existing customer  */
  EC_AUDIENCE_ID: '2jMKO2QMpbfAnyQ2strEtw',
  /** Ninetailed audience ID for new customer  */
  NC_AUDIENCE_ID: '2cYqL4coJKzk99J1MrVzdn',
} as const;

export type AudienceIds = (typeof AudienceIds)[keyof typeof AudienceIds];
